import GET_LINK_BLOCK from '../plugins/get-link-block'
import GET_MENU_HEADER from '../plugins/get-menu-header'
import GET_NAV_MENU from '../plugins/get-nav-menu'

const [w, d, mq] = [window, document, window.matchMedia("(max-width: 900px)")]

const init = () => {

  // リンクブロック、バナーブロック 呼び出し
  $.when(w.load['loadHtml']).then(() => {
    GET_LINK_BLOCK()
    GET_MENU_HEADER()
    GET_NAV_MENU()
  })
  if( w.load['loadHtml'] ){
    w.load['loadHtml'].then( () => {
      // ナビゲーションカレント
      $('.nav-menu[data-plugin="currentMenu"]').currentMenu({mode:0})
    })
  }

  // $.when(
  //   w.load['menu-oil'],
  //   w.load['menu-body'],
  //   w.load['menu-facial']
  // ).then((oil, body, facial) => {
  //   let slot = {
  //     'oil': oil[1],
  //     'body': body[1],
  //     'facial': facial[1]
  //   }
  //   $('[data-slot]').each((i, obj) => {
  //     const slotName = obj.dataset.slot
  //     if (slot[slotName] != null) {
  //       $(obj).empty().prepend(slot[slotName])
  //     }
  //   })
  // })
}

export default function MENU() {
  $(init)
}